`<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
<div>
  <form @submit.prevent="smsAction" method="post" action="/">
    <vs-input
      name="smsCode"
      icon-no-border
      icon="icon icon-user"
      icon-pack="feather"
      :label-placeholder="$t('message.login.smsField')"
      @keydown.enter.prevent="smsAction"
      v-model="smsCode"
      class="w-full my-6"/>

    <a href="javascript: void(0)"
       :class="{disabled: !!timer}"
       @click="secondSend">
      {{ $t('message.login.smsSecondButton', {timeout}) }}
    </a>

    <div class="h-6">
      <vs-button
        class="float-right"
        button="submit"
        v-html="$t('message.login.smsButton')"></vs-button>
    </div>
  </form>

</div>
</template>

<script>
export default {
  data () {
    return {
      smsCode: '',
      timeout: 0,
      time: 60,
      timer: null
    }
  },
  methods: {
    smsAction () {
      if (this.smsCode.length > 0) this.$emit('confirm-code', {'user_code': this.smsCode})
    },
    secondSend () {
      if (!this.timer) {
        this.$emit('second-code', {})
        this.setTimeout()
      }
    },
    setTimeout () {
      this.timeout = this.time
      this.timer = window.setInterval(() => {
        this.timeout -= 1
        if (this.timeout === 0) {
          window.clearTimeout(this.timer)
          this.timer = false
        }
      }, 1000)
    }
  },
  mounted () {
    this.setTimeout()
  }
}
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1
    }

    .bg-twitter {
      background-color: #00aaff
    }

    .bg-google {
      background-color: #4285F4
    }

    .bg-github {
      background-color: #333
    }
  }

  .disabled {
    pointer-events: none;
    color: #9c9c9c
  }
}
</style>
